// startup
// Load entry module and return exports
// This entry module can't be inlined because the eval devtool is used.
var __webpack_exports__ = {};
__webpack_modules__["./source/scripts/templates/template.collection.js"]();
